module.exports = __webpack_public_path__ + "static/partners-d307a1cd006015ae90da3be291524b3e.png";